var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.roles.isAdmin)?_c('div',[_c('statistics-admin')],1):(_vm.roles.isHR)?_c('div',[_c('statistics-hr')],1):_c('div',[_c('statistics-hod')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }